import hasEnumeratedWorkflowMemory from '@/screens/workflows/lib/hasEnumeratedWorkflowMemory.js';

/**
 * Carries an already-loaded memory enumeration onto incoming workflow rows.
 *
 * Workflow reads serve `variables.memory` as `{}` when the workflow does not depend on memory, and
 * the row merges replace a matching row wholesale. Without this, a sync refetch of a workflow-level
 * edit (a canvas move, a rename) blanks every memory surface and makes the lazy loader re-enumerate
 * S3 all over again. Memory is scoped by workflow + environment + installation, never by workflow
 * revision, so a newer row is no reason to drop it.
 */
const withPreservedWorkflowMemory = (currentRows = [], incomingRows = []) => {
  if (!Array.isArray(incomingRows) || incomingRows.length === 0) {
    return incomingRows;
  }

  return incomingRows.map((incoming) => {
    if (hasEnumeratedWorkflowMemory(incoming?.variables?.memory)) {
      return incoming;
    }

    const current = currentRows?.find((n) => n?.id === incoming?.id && n?.version === incoming?.version);
    if (!hasEnumeratedWorkflowMemory(current?.variables?.memory)) {
      return incoming;
    }

    return { ...incoming, variables: { ...incoming?.variables, memory: current.variables.memory, memoryScope: current.variables.memoryScope } };
  });
};

export default withPreservedWorkflowMemory;
